module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAAAsTAAALEwEAmpwYAAAA70lEQVQ4ja3UoUpEQRQG4G9lgsVFEGSDRQSjD2DR7JvYjAsGMYjZ4n0Bg2Gz3SfYcpOsq2GDmxRkQRaD5V7RcVdOmFOGgZ+P4cyZ6QyGswp7ytQoNdh+IbCbcIHNQuBrwl0hDKRAZh0nQW+6CNzBYwaeBcE6B/voZSf6wH0QHP8E+7jEVRZ6wWEQ/O5hiy3LbAW9ecLxP5gGewqC9Qreg+FQJdxgDddLMhNsB71528OqWRehn3gOgr8Gu0V3s0wPt0FvnM9h5e+NruIgCG4seimTbP+G8yA47QyGs2A2VglHCn9fp8p9sHXCCN1C4MMXb3Eq90JuN5oAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/components/waterSystem/img/left_dark.png
// module id = HMX9
// module chunks = 157